﻿var idpApp = new Vue({
    el: '#idp-app',
    data: {
        viewType: '',
        baseUrl: '',
        idpList: {},
        selectedIdp: '',
        returnUrl: ''
    },
    methods: {
        selectIdp: function(idp) {
            if (idp !== this.selectedIdp) {
                window.location.href = this.baseUrl + '?ReturnUrl=' + this.returnUrl + '&selectedIdpValue=' + idp;
            }
        },
        iconButton: function(idp) {
            let classList = []
            if (idp === this.selectedIdp) {
                classList.push('active')
            }
            classList.push('icon')
            classList.push('icon--' + idp)

            return classList.join(' ')
        }
    }
})
